import { produce } from 'immer';
import { getType } from 'typesafe-actions';

import { ActionsOf } from '../../../helpers/actions';
import * as pointsActions from './actions';

import { DataProps, ThemesProps } from 'src/components/modules/points/types/types';
import { WidgetThemesProps } from 'src/components/modules/points/types/pointsWidgetstypes';

export interface PointsEntityState {
  error: boolean;
  loading: boolean;
  saving: boolean;
  points: ThemesProps;
  siteId: number;
  lastUpdated: string;
  errorMessage: string;
}

export interface PointsWidgetsEntityState {
  error: boolean;
  loading: boolean;
  saving: boolean;
  points: WidgetThemesProps;
  siteId: number;
  lastUpdated: string;
  errorMessage: string;
}

const initialState = {
  error: false,
  loading: false,
  saving: false,
  points: {},
  siteId: -1,
  lastUpdated: '-',
  errorMessage: '',
};

type PointsActions = ActionsOf<typeof pointsActions>;

export const pointsEntityReducer = produce((draft, action: PointsActions) => {
  switch (action.type) {
    case getType(pointsActions.getPoints.request): {
      draft.loading = true;
      draft.error = false;
      draft.siteId = action.payload.siteId;
      draft.lastUpdated = '-';
      draft.errorMessage = '';

      return;
    }
    case getType(pointsActions.getPoints.success): {
      const { result } = action.payload as { result: DataProps };
      draft.points = result.themes;
      draft.loading = false;
      draft.lastUpdated = result.age.replace('T', ' ').slice(0, 19);

      return;
    }
    case getType(pointsActions.getPoints.error): {
      const {
        error: { message },
      } = action.payload;

      draft.loading = false;
      draft.error = true;
      draft.errorMessage = message;

      return;
    }

    case getType(pointsActions.savePoints.request): {
      draft.saving = true;

      return;
    }
    case getType(pointsActions.savePoints.success): {
      draft.saving = false;

      return;
    }
    case getType(pointsActions.savePoints.error): {
      draft.saving = false;

      return;
    }
  }
}, initialState);
